import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class GameSessionConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getGameSessionCloseEndpoint(): string {
		return this.configService.get(
			(x) => x.core.gameSession.endpoints!.closeGameSession,
			"v1/gameplay/game-sessions/closegamesession"
		);
	}
}
